import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import qs from 'qs';
export function useUpdateLocationFromFilter() {
    var filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var history = useHistory();
    var location = useLocation();
    useEffect(function() {
        if (filter && Object.keys(filter).length > 0) {
            var queryStr = qs.stringify(filter, {
                arrayFormat: 'brackets',
                encode: false
            });
            if (queryStr) {
                history.replace(location.pathname + '?' + queryStr);
            } else {
                history.replace(location.pathname);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(filter)
    ]);
}
